import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '../firebase/firebaseInit'

const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'Not Found',
    redirect: '/admin'
  },
  // {
  //   path: '/frame/ad/',
  //   name: 'Frame-Ads',
  //   component: () => import('../views/ads-frame.vue')
  // },
  // end of ads frames
  {
    path: '/auth',
    name: 'Login',
    component: () => import('../views/auth.vue'),
    meta: {
      title: 'Welcome Admin.',
    }
  },
  {
    path: '/admin/',
    name: 'Admin Page',
    component: () => import('../views/admin/AdminPage.vue'),
    meta: {
      title: 'Admin',
      requiresAuth: true
    }
  },
  {
    path: '/admin/ads-managment',
    name: 'ads-managment',
    component: () => import('../views/admin/ads-managment.vue'),
    meta: {
      title: 'Ads-Manager',
      requiresAuth: true
    }
  },
  {
    path: '/admin/ads-managment/edit',
    name: 'ads-editor',
    component: () => import('../views/admin/ads-editor.vue'),
    meta: {
      title: 'Ads-editor',
      requiresAuth: true
    }
  },
  // IPUMON Services Async-STARSytems
  // S.T.A.R.S.
  // STARSytems
  {
    path: '/admin/stars/',
    name: 'STARS',
    children: [
      { path: ':STARSid', name: 'STARSytem', component: () => import('../views/admin/STARS/Services.vue')},
      { path: '', name: 'STARSytems', component: () => import('../views/admin/STARS/Services.vue')},
      { path: 'view/:STARSid', name: 'Ticket Viewer', component: () => import('../views/admin/STARS/TicketsEditor.vue'), meta: {Mode: 'lock'}},
      { path: 'edit/:STARSid', name: 'Ticket Editor', component: () => import('../views/admin/STARS/TicketsEditor.vue')},
    ],
    meta: {
      title: 'STARStyems',
      requiresAuth: true
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, form, next) => {
  // const browserHeaderTitle = to.name
  document.title = to.meta.title ? to.meta.title : 'Web-C IPUMON';
  var currentUrl = window.location.pathname;
  if (to.path === currentUrl && auth.currentUser) {
    next()
    return;
  }
  
  if (to.matched.some(record => record.meta.requiresAuth) && !auth.currentUser) {
    next("/auth")
    return;
  }

  next();
})
export default router
